import React, {useEffect, useState} from 'react';
import {Card, CardContent, CardHeader, Grid, Typography} from '@material-ui/core';
import {SecondaryButton} from '../common/StyledButtons';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {changePassword, changePasswordWithToken} from '../../api';
import queryString from 'query-string';
import PropTypes from 'prop-types';

export default function ChangePasswordForm(props) {
    const minChar = 6;
    const maxChar = 256;
    const {addFlashMessage, cancelAction, token, successAction} = props;
    const [submitting, setSubmitting] = useState(false);
    const [currentPass, setCurrentPass] = useState('');
    const [newPass, setNewPass] = useState('');
    const [confPass, setConfPass] = useState('');

    const handleChange = (e, setStateFunc) => {
        setStateFunc(e.target.value);
    };

    const clearFields = () => {
        setCurrentPass('');
        setNewPass('');
        setConfPass('');
    };

    const validateAndSave = () => {
        const pwdRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\s])/);
        let success = false;
        let message = '';

        if (newPass !== confPass) {
            message =
                'Failed to change password - New password and confirm password do not match';
            setSubmitting(false);
            addFlashMessage(message);
        } else if (newPass.length > maxChar || newPass.length < minChar) {
            message =
                `Failed to change password - Password must be between ${minChar} and ${maxChar} characters in length`;
            setSubmitting(false);
            addFlashMessage(message);
        } else if (!pwdRegex.test(newPass)) {
            message =
                'Failed to change password - \n' +
                'Password must contain at least one number, symbol, capital and lowercase letter';
            setSubmitting(false);
            addFlashMessage(message);
        } else {
            if (token) {
                changePasswordWithToken(newPass, token)
                    .then(() => {
                        success = true;
                        message = 'Successfully changed password';
                    }).catch(err => {
                        success = false;
                        message = err.message;
                    }).finally(() => {
                        setSubmitting(false);
                        if (success) {
                            clearFields();
                        }
                        successAction(message, success);
                    });
            }
            else {
                changePassword(newPass, currentPass)
                    .then(() => {
                        success = true;
                        message = 'Successfully changed password';
                    }).catch(err => {
                        success = false;
                        message = err.message;
                    }).finally(() => {
                        setSubmitting(false);
                        if (success) {
                            clearFields();
                        }
                        successAction(message, success);
                    });
            }
        }
    };

    useEffect(() => {
        if (submitting) {
            validateAndSave();
        }
    }, [submitting]);

    return (
        <Card className="center-all">
            <CardHeader
                title={<Typography color="primary" variant="h6" className="modal-card-title">Change
                    Password</Typography>}/>
            <CardContent>
                <Grid container spacing={1}>
                    {!token && <Grid item xs={12}>
                        <CustomPasswordField
                            name="currentPass"
                            label="Current Password"
                            value={currentPass}
                            rules={[
                                {required: true, message: 'Please enter your current password'},
                            ]}
                            onChange={(e) => handleChange(e, setCurrentPass)}
                        />
                    </Grid>}
                    <Grid item xs={12}>
                        <CustomPasswordField
                            name="newPass"
                            label="New Password"
                            value={newPass}
                            rules={[
                                {required: true, message: 'Please enter a new password'},
                            ]}
                            onChange={(e) => handleChange(e, setNewPass)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomPasswordField
                            name="newPassConfirm"
                            label="Confirm New Password"
                            value={confPass}
                            rules={[
                                {required: true, message: 'Please confirm your new password'},
                            ]}
                            onChange={(e) => handleChange(e, setConfPass)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SecondaryButton
                            disabled={submitting || newPass === '' || confPass === '' || (currentPass === '' && !token)}
                            onClick={() => setSubmitting(true)}>
                            Change Password
                        </SecondaryButton>
                        {!token && <Button color="primary" onClick={cancelAction}>Cancel</Button>}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}


ChangePasswordForm.propTypes = {
    addFlashMessage: PropTypes.func.isRequired,
    successAction: PropTypes.func.isRequired,
    cancelAction: PropTypes.func,
    token: PropTypes.string,
};

function CustomPasswordField(props) {
    return (
        <TextField
            type="password"
            variant="outlined"
            margin="dense"
            fullWidth
            autoComplete="off"
            {...props}
        />
    );
}